import React, { useEffect, useState } from 'react';
import '../css/surveyExpired.css';

const InactiveSUrvey = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <div className="expired-container">
      <div className={`expired-card ${isVisible ? 'visible' : ''}`}>
        <div className="expired-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="80" height="80" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <h1 className="expired-title">Survey Not Found</h1>
        <p className="expired-message">
        We're sorry, but this survey does not exist or may have been removed.
        </p>
      </div>
    </div>
  );
};

export default InactiveSUrvey; 